import { render, staticRenderFns } from "./ChatButton.vue?vue&type=template&id=46558181&"
import script from "./ChatButton.vue?vue&type=script&lang=js&"
export * from "./ChatButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46558181')) {
      api.createRecord('46558181', component.options)
    } else {
      api.reload('46558181', component.options)
    }
    module.hot.accept("./ChatButton.vue?vue&type=template&id=46558181&", function () {
      api.rerender('46558181', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/ChatButton.vue"
export default component.exports